import { t, translate } from "restaumatic-client/src/I18n";
/**
 * The `data-ai-provenance` attribute for an image, spread onto the `<img>` element.
 *
 * Absent provenance means the image resolves to no media library item — unknown, not
 * "no AI" — so no attribute is emitted at all rather than an empty one.
 */
export function aiProvenanceAttrs(provenance) {
    return provenance == null ? {} : { "data-ai-provenance": provenance };
}
/**
 * Provenance for an image that reaches the page through `Skubacz.configuration` rather
 * than through the menu. The imgix query is stripped the same way the server does when
 * it builds the map.
 */
export function aiProvenanceForUrn(urn) {
    var _a;
    if (urn == null) {
        return null;
    }
    const map = Skubacz.configuration.media_ai_provenance;
    return (_a = map === null || map === void 0 ? void 0 : map[urn.split("?")[0]]) !== null && _a !== void 0 ? _a : null;
}
export function aiProvenanceLabel(provenance) {
    switch (provenance) {
        case "AiGenerated":
            return translate(t.menu.aiProvenance.aiGenerated);
        case "AiModified":
            return translate(t.menu.aiProvenance.aiModified);
        default:
            return null;
    }
}
export function aiProvenanceShortLabel() {
    return translate(t.menu.aiProvenance.short);
}
